module.exports = __webpack_public_path__ + "img/login_bg_new3.2e9d4562.png";